/**
 * Lite Group 脈絡下跳轉時保留 groupId（SSOT）
 */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { appendGroupIdToPath } from '../utils/liteNavigation';

/**
 * 回傳導向函數：有 groupId 時會附加到 path 的 query
 */
export function useNavigateWithGroupId(): (path: string) => void {
  const navigate = useNavigate();
  return useCallback(
    (path: string) => {
      navigate(appendGroupIdToPath(path));
    },
    [navigate]
  );
}
